import React from 'react';
import styles from '../../styles/ConceptosCobroStyles/ConceptosCobro.module.css';

function ViewConceptModal({ isOpen, onClose, concepto }) {
  if (!isOpen || !concepto) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Ver Concepto de Cobro</h2>
        </div>

        <div className={styles.modalContent}>
          <div className={styles.tabContent}>
            <h3 className={styles.sectionTitle}>Información General</h3>
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Nombre del concepto</label>
                <div className={styles.readOnlyField}>{concepto.nombre || '-'}</div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Código del concepto</label>
                <div className={styles.readOnlyField}>{concepto.codigo || '-'}</div>
              </div>
            </div>

            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Institución</label>
                <div className={styles.readOnlyField}>{concepto.institucion_nombre || '-'}</div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Campus</label>
                <div className={styles.readOnlyField}>{concepto.campus_nombre || '-'}</div>
              </div>
            </div>

            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Ciclo Escolar</label>
                <div className={styles.readOnlyField}>{concepto.ciclo || '-'}</div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Sección</label>
                <div className={styles.readOnlyField}>{concepto.seccion_nombre || '-'}</div>
              </div>
            </div>

            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Descripción</label>
              <div className={styles.readOnlyField}>{concepto.descripcion || '-'}</div>
            </div>

            <h3 className={styles.sectionTitle}>Configuración del cobro</h3>
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Aplicación del concepto</label>
                <div className={styles.readOnlyField}>{concepto.aplicacion || '-'}</div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Subcategoría</label>
                <div className={styles.readOnlyField}>{concepto.subcategoria || '-'}</div>
              </div>
            </div>

            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Categoría</label>
                <div className={styles.readOnlyField}>{concepto.categoria || '-'}</div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Periodicidad</label>
                <div className={styles.readOnlyField}>{concepto.periodicidad || '-'}</div>
              </div>
            </div>

            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Permite parcialidades</label>
                <div className={styles.readOnlyField}>
                  {concepto.permite_parcialidades ? 'Sí' : 'No'}
                </div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Estado</label>
                <div className={styles.readOnlyField}>{concepto.estado || '-'}</div>
              </div>
            </div>

            <h3 className={styles.sectionTitle}>Vigencia</h3>
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Fecha de inicio</label>
                <div className={styles.readOnlyField}>{concepto.fecha_vigencia_inicio || '-'}</div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Fecha de fin</label>
                <div className={styles.readOnlyField}>{concepto.fecha_vigencia_fin || '-'}</div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.modalActions}>
          <button className={styles.cancelButton} onClick={onClose}>
            CERRAR
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewConceptModal;
